module.exports = __webpack_public_path__ + "static/media/bm.55b93e10.svg";